/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const CircleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M10 0.579971C8.02219 0.579971 6.08879 1.16646 4.4443 2.26528C2.79981 3.36409 1.51809 4.92588 0.761209 6.75314C0.00433284 8.5804 -0.193701 10.5911 0.192152 12.5309C0.578004 14.4707 1.53041 16.2525 2.92894 17.651C4.32746 19.0496 6.10929 20.002 8.0491 20.3878C9.98891 20.7737 11.9996 20.5756 13.8268 19.8188C15.6541 19.0619 17.2159 17.7802 18.3147 16.1357C19.4135 14.4912 20 12.5578 20 10.58C20 9.26675 19.7413 7.96639 19.2388 6.75314C18.7363 5.53988 17.9997 4.43749 17.0711 3.5089C16.1425 2.58032 15.0401 1.84372 13.8268 1.34118C12.6136 0.838629 11.3132 0.579971 10 0.579971ZM10 18.58C8.41775 18.58 6.87104 18.1108 5.55544 17.2317C4.23985 16.3527 3.21447 15.1032 2.60897 13.6414C2.00347 12.1796 1.84504 10.5711 2.15372 9.01925C2.4624 7.4674 3.22433 6.04194 4.34315 4.92312C5.46197 3.8043 6.88743 3.04237 8.43928 2.73369C9.99113 2.42501 11.5997 2.58343 13.0615 3.18894C14.5233 3.79444 15.7727 4.81982 16.6518 6.13541C17.5308 7.451 18 8.99772 18 10.58C18 12.7017 17.1572 14.7365 15.6569 16.2368C14.1566 17.7371 12.1217 18.58 10 18.58Z"
        fill="black"
      />
    </svg>
  )
}
